import React, { useState, useEffect, useContext } from 'react';
import AssetSubCategoryService from "../../controller/AssetSubCategoryController/AssetSubCategoryController";
import AssetCategoryService from "../../controller/AssetCategoryController/AssetCategoryController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CreateAssetSubCategory from './CreateAssetSubCategory';
import HelpSite from "../../../Common/HelpLink";
import Cookies from "js-cookie";
function AssetSubCategoryListPage() {
    const navigate = useNavigate();
    const [assetSubCategories, setAssetSubCategories] = useState([]);
    const { theme } = useContext(ThemeContext);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [modalInstance, setModalInstance] = useState(null);
    const [assetCategories, setAssetCategories] = useState([]);
    const [currentAssetCategory, setCurrentAssetCategory] = useState(null);

    const [currentPage, setCurrentPage] = useState(1); // Current page
    const UserID = localStorage.getItem("UserID");
    const CompanyID = localStorage.getItem("CompanyID");

    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const setSortConfigInCookie = (config) => {
        Cookies.set(`AssetSubCategorySort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`AssetSubCategorySort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };

    useEffect(() => {
        fetchAssetSubCategories(currentPage, pageSize);

    }, [currentPage, pageSize]);
    useEffect(() => {
        fetchAssetSubCategories(currentPage, pageSize);

    }, [sortConfig]);

    useEffect(() => {
        setModalInstance(new window.bootstrap.Modal(document.getElementById('assetSubCategoriesModal')));
    }, []);

    const fetchAssetSubCategories = async (page, size) => {
        try {
            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();
            const assetSubCategoryData = await AssetSubCategoryService.GetAllAssetSubCategories(redirectCallback, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
            setAssetSubCategories(assetSubCategoryData);
        } catch (error) {
            console.error('Error fetching Asset Sub Categories:', error);
        }
    };

    const fetchAssetCategories = async () => {
        try {
            const assetCategoryData = await AssetCategoryService.GetAllAssetCategories(redirectCallback, "1", "1000",
                "", sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
            setAssetCategories(assetCategoryData);
        } catch (error) {
            console.error('Error fetching Asset Categories:', error);
        }
    };

    const handleCreateAssetSubCategoriesClick = async () => {
        setCurrentAssetCategory(null);
        await fetchAssetCategories();
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleCloseModal = () => {
        if (modalInstance) {
            modalInstance.hide();
        }
    };

    const handleEditClick = async (asset) => {
        await fetchAssetCategories();
        setCurrentAssetCategory(asset); // Set the asset subcategory to be edited
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleDeleteClick = async (ID) => {
        const confirmed = window.confirm("Are you sure you want to delete this asset subcategory?");
        if (confirmed) {
            try {
                await AssetSubCategoryService.DeletAssetSubCategory(ID); // Ensure this matches the actual function name in your service
                fetchAssetSubCategories(); // Fetch the updated list of asset subcategories
            } catch (error) {
                console.error('Error deleting asset subcategory:', error);
            }
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');

    const defaultColumns = [
        "AssetCategory",
        "SubCategoryName",
        "dec_DepRate"


    ];
    const defaultColumnsForSearch = [
        "AssetCategory",
        "SubCategoryName",
        "dec_DepRate"

    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnOptions = [
        { value: "AssetCategory", label: "AssetCategory" },
        { value: "SubCategoryName", label: "SubCategoryName" },
        { value: "dec_DepRate", label: "dec_DepRate" }

    ];
    const columnSearchOptions = [
        { value: "AssetCategory", label: "AssetCategory" },
        { value: "SubCategoryName", label: "SubCategoryName" },
        { value: "dec_DepRate", label: "dec_DepRate" }

    ];
    const handleSearchColumnChange = (selectedOptions) => {
        setSearchColumns(selectedOptions);

    };
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`assetSubCategoryColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`assetSubCategoryColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };

    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page


        let columnsToSearch = searchColumns.length > 0
            ? searchColumns.join(",")
            : "ALL";

        setSearchOptions(columnsToSearch);
        const query = searchQuery.toLowerCase(); // Use current searchQuery state

        const locationData = await AssetSubCategoryService.GetAllAssetSubCategories(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setAssetSubCategories(locationData);

    };
    const handleSort = async (key) => {

        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);
        //   const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });
        const query = searchQuery.toLowerCase();
        const locationData = await AssetSubCategoryService.GetAllAssetSubCategories(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setAssetSubCategories(locationData);

    };
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-3">
                    <button className='btn btn-primary btn-sm' onClick={handleCreateAssetSubCategoriesClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Asset Sub Category" Module="26" />
                </div>
            </div>
            <div className="row mb-3">

                <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                    </select>
                </div>
                <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                <div className="col-sm-6"></div>
                <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>


                </div>
                <div className="col-sm-2 d-flex justify-content-end">
                    <input
                        list="recent-searches"
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="form-control me-2"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSearchButtonClick();
                            }
                        }}
                    />

                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                        <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                </div>



            </div>
            <table className="table m-0 table-hover">
                <thead>
                    <tr>

                        <th onClick={() => handleSort('AssetCategory')}>Asset Category</th>
                        <th onClick={() => handleSort('SubCategoryName')}>Sub Category</th>
                        <th onClick={() => handleSort('dec_DepRate')}>Depn %</th>
                        <th style={{ "textAlign": "right" }}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {assetSubCategories.map((asset, index) => (

                        <tr key={asset.ID} onClick={() => handleEditClick(asset)}>

                            <td>{asset.AssetCategory}</td>
                            <td>{asset.SubCategoryName}</td>
                            <td>{asset.dec_DepRate}</td>
                            <td style={{ "textAlign": "right" }}>

                                <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleDeleteClick(asset.ID)}>
                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <CreateAssetSubCategory
                asset={currentAssetCategory}
                onClose={handleCloseModal}
                onSuccess={fetchAssetSubCategories}
                assetCategories={assetCategories}
            />
        </div>
    );
}

export default AssetSubCategoryListPage;
